module.exports = __webpack_public_path__ + "static/media/kota.067b2271.jpg";